<form [formGroup]="formGroup" autocomplete="off" *ngIf="formGroup">
  <maporium-title-description (fieldsChange)="onTitleDescriptionChange($event)"
                              (titleInputChange)="onInstantNameChange($event)"
                              (nameFieldFocus)="onNameFieldFocus()"
                              (nameFieldBlur)="onNameFieldBlur()"
                              (descriptionFieldFocus)="onDescriptionFieldFocus()"
                              (descriptionFieldBlur)="onDescriptionFieldBlur()"
                              [entityId]="focusedLink?.id"
                              [isNew]="focusedLink?.isNew || false"
                              [fields]="{title: formGroup.get('name')?.value, description: formGroup.get('description')?.value || ''}"
                              [isEditing]="true"></maporium-title-description>

  <div class="mt-3">
    <cdk-accordion [multi]="true" class="accordion">
      <maporium-accordion-item *appHasModule="MODULE_NAMES.METADATA_BINDING"
                               [iconClass]="'icon-smap-object-property'"
                               tourAnchor="properties-anchor"
                               [sections]="visibleMetaCount"
                               [title]="'MAP_INFO.PROPERTIES' | translate">
        <maporium-meta-data-control (extendMeta)="extendMeta.emit()"
                                    formControlName="metadata">
        </maporium-meta-data-control>
      </maporium-accordion-item>
      <ng-container *appHasPackage="[PACKAGE_NAMES.developer]">
        <maporium-accordion-item [iconClass]="'icon-smap-object-property'"
                                 [sections]="hasBottleneckMark ? 1 : 0"
                                 [title]="'SHARED_FORMS.BOTTLENECK' | translate">
          <maporium-bottleneck-marker [metadata]="focusedLink?.metadata"
                                      (metadataChange)="onBottleneckChange($event)"></maporium-bottleneck-marker>
        </maporium-accordion-item>
      </ng-container>

      <maporium-accordion-item *hasMapPermission="'comment'"
                               [iconClass]="'icon-smap-object-comment'"
                               [sections]="commentsCount" [title]="'MAP_INFO.COMMENTS' | translate">
        <maporium-comments (updated)="this.focusedLink!.hasComments = $event"
                           (commentCount)="commentsCount = $event"
                           [entityId]="focusedLink!.id"
                           [entityType]="'link'"
                           [isEditing]="!isDefaulter">
        </maporium-comments>
      </maporium-accordion-item>
      @if (currentMap?.hasGuestComments && isInIframe()) {
        <maporium-accordion-item [sections]="commentsCount"
                                 [iconClass]="'icon-smap-object-comment'"
                                 [title]="'MAP_INFO.COMMENTS' | translate">
          <maporium-comments (updated)="this.focusedLink!.hasComments = $event"
                             (commentCount)="commentsCount = $event"
                             [entityId]="focusedLink!.id"
                             [entityType]="'link'">
          </maporium-comments>
        </maporium-accordion-item>
      }
      <maporium-accordion-item [sections]="sectionsCount"
                               [iconClass]="'icon-smap-object-style'"
                               [title]="'MAP_INFO.STYLES.TITLE' | translate">
        <maporium-link-style [focusedLink]="focusedLink"
                             [formGroup]="formGroup"
                             [metadata]="focusedLink?.metadata"></maporium-link-style>
      </maporium-accordion-item>

      @if (!isDefaultState) {
        <maporium-accordion-item [title]="'STATES.TITLE' | translate"
                                 [iconClass]="'icon-smap-object-state-custom'"
        >
          <app-select-input formControlName="excludedFromState"
                            class="mb-1"
                            [label]="'unknown_2'"
                            [isIcon]="true"
                            [options]="excludeFromStateOptions"
                            [placeholder]="'LINKS.LINK_INCLUSION' | translate">
          </app-select-input>
          <div class="d-flex mt-2 justify-content-center no-gutter">
            <button class="reset-button"
                    mat-flat-button
                    (click)="resetState()">{{ 'STATES.REVERT_TO_BASE' | translate }}
            </button>
          </div>
        </maporium-accordion-item>
      }
    </cdk-accordion>
  </div>
</form>
